import { Form, Button, Col, Row, Table, } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useState, useEffect } from 'react';
import { FaEdit, FaRegStickyNote, FaTrash, } from 'react-icons/fa';

import axios from "axios";
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import QualitativeModal from './qualitativeModal';
import QuantitativeModal from './quantitativeModal';
import { SpinnerModal, generateYears, getFiscalYear } from '../Util';
import PerformanceDataModal from './performanceDataModal';

export default function PerformanceResponse() {

    const years = generateYears(2020, new Date().getFullYear());
    const PERFORMANCE_BASE_URL = process.env.REACT_APP_PERFORMANCE_BASE_URL;
    const PERFORMANCE_PUT = process.env.REACT_APP_PERFORMANCE_PUT;
    const PERFORMANCE_GET_ID = process.env.REACT_APP_PERFORMANCE_GET_ID;


    const data = {
        type: "PERFORMANCE",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        performanceData: [],
        personnel: {
            noOfPhmcStaff: "",
            noOfAssociateStaff: "",
            noOfVolunteers: ""
        },
        remarks: "",
        acknowledge: false
    }

    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const profile = JSON.parse(storedUser);
            setUserRole(profile.role);
        }
    }, []);

    const [formData, setFormData] = useState(data);
    const [saveShow, setSaveShow] = useState(false);
    const handleShow = () => setSaveShow(true);
    let { id } = useParams();
    useEffect(() => {
        const recordId = id;
        console.log(recordId);
        const url = PERFORMANCE_BASE_URL + recordId + PERFORMANCE_GET_ID;
        console.log(url);
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setFormData(data);
            })
    }, []);


    const navigate = useNavigate();
    const handleApprove = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "APPROVED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };
    const handleReject = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "REJECTED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = `${PERFORMANCE_BASE_URL}${formData._id}${PERFORMANCE_PUT}`;
        // Call REST API to store the data
        axios.put(url, formData
        ).then((response) => {
            console.log(response.status, response.data);
            setFormData(data);
            navigate("/performanceView");
        }).catch((error) => {
            console.log(error);
        });
    }

    const [performanceDataItem, setPerformanceDataItem] = useState();
    const [performanceDataShow, setPerformanceDataShow] = useState(false);
    const handlePerformanceDataClose = () => { setPerformanceDataItem(null); console.log('data item:' + performanceDataItem); setPerformanceDataShow(false); }
    const handlePerformanceDataShow = () => { setPerformanceDataShow(true); }

    const handlePerformanceDataItem = (data) => {
        console.log(`data item: ${data}`);
        setPerformanceDataItem(data);
        handlePerformanceDataShow();
    }



    return (
        <>

            <span ><b>Performance Data</b> </span>
            {/* {saveShow &&
                <SaveModal onClose={handleSaveClose} onSave={handleSubmission} formData={performanceForm.values} />
            } */}

            <div className="main-content">
                <Form className="main-content" noValidate >
                    <PerformanceDataModal show={performanceDataShow} onClose={handlePerformanceDataClose} dataItem={performanceDataItem} />
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="formGridEmail" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="" name="siteName" value={formData.siteName} readOnly>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Year</Form.Label>
                            <Form.Select name="year" value={formData.year} readOnly>
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </Form.Select>

                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="" name="month" value={formData.month} readOnly
                            >
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>

                        </Form.Group>
                    </Row>
                    {/* Performance data */}
                    <Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Performance Data</Card.Title>

                                    <Row className="mb-3 main-content" >
                                        <Table striped bordered hover variant="light" responsive="md">
                                            <thead>
                                                <tr>
                                                    <th>Program Category</th>
                                                    <th>Program Type</th>
                                                    <th>Program Name</th>
                                                    <th>Program Date</th>
                                                    <th>Target Audiences</th>
                                                    <th>Event Type</th>
                                                    <th>Event Location</th>
                                                    <th>Location of Attendees</th>
                                                    <th>Net Revenue</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.performanceData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.qualitative.programCategory}</td>
                                                        <td>{item.qualitative.programType}</td>
                                                        <td>{item.qualitative.programName}</td>
                                                        <td>{item.qualitative.programDate}</td>
                                                        <td>{item.quantitative.targetAudiences}</td>
                                                        <td>{item.quantitative.virtualOrInPerson}</td>
                                                        <td>{item.quantitative.onsiteOrOffsite}</td>
                                                        <td>{item.quantitative.countyHeld}</td>
                                                        <td>{item.netRevenue}</td>
                                                        <td ><Button variant="transparent" onClick={() => handlePerformanceDataItem(item)}> <FaEdit /></Button>
                                                            <Button variant="transparent" > <FaTrash /></Button></td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* Personnel */}
                    <Row className="mb-3 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Personnel</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="noOfPhmcStaff">
                                            <Form.Label>No of PHMC staff needed</Form.Label>
                                            <Form.Control type="number" name="personnel.noOfPhmcStaff" readOnly value={formData.personnel.noOfPhmcStaff} />

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="noOfAssociateStaff">
                                            <Form.Label>No of Associate staff needed</Form.Label>
                                            <Form.Control type="number" name="personnel.noOfAssociateStaff" readOnly value={formData.personnel.noOfAssociateStaff} />

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="noOfVolunteers">
                                            <Form.Label>No of Volunteers needed</Form.Label>
                                            <Form.Control type="number" name="personnel.noOfVolunteers" readOnly
                                                value={formData.personnel.noOfVolunteers}
                                            />

                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>

                                <Card.Body>
                                    <Card.Title>Remarks</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="remarks">
                                            <Form.Label>Site Comments</Form.Label>
                                            <Form.Control as="textarea" aria-label="Remarks" readOnly name="remarks" value={formData.remarks} />

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="phmcremarks">
                                            <Form.Label>PHMC Comments</Form.Label>
                                            <Form.Control as="textarea" aria-label="Remarks" name="phmcremarks" value={formData.phmcremarks} />

                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>

                    {userRole && userRole !== 'OBSERVER' &&
                        <Row className="mb-3 main-content">

                            <Col>
                                <Row className="mb-3 submit">
                                    <Col>


                                        {formData.status !== 'APPROVED' && (
                                            <Col>
                                                <Button variant="primary" className="m-1" onClick={handleApprove}>Approve</Button>
                                            </Col>
                                        )}


                                        <Button variant="primary" name="reject" onClick={handleReject} >
                                            Reject
                                        </Button>

                                    </Col>
                                </Row>
                            </Col>


                            <Col />
                            <Col />
                            <Col />
                        </Row>
                    }
                    {/* <SpinnerModal show={spinnerShow} onHide={() => setSpinnerShow(false)} /> */}
                </Form>
            </div >
        </>
    );

}